( function( $ ) {
	let initBlock = function() {
		let $sectionInstance = $( '.section-woo-product-reviews' );
		
		function reviewsFormPreparation() {        
			$( '#review_form' ).find( '.wp-element-button' ).addClass( 'button' );

			$( '#review_form' ).find( 'label' ).each( function() {
				let excludeLabels = [
					'rating',
					'wp-comment-cookies-consent'
				];

				let inputElementId = $( this ).attr( 'for' );

				if ( !excludeLabels.includes( inputElementId ) ) {
					let inputElement = $( '#' + inputElementId );

					if ( inputElement.length ) {
						inputElement.attr( 'placeholder', $( this ).text() );
						$( this ).hide();
					}
				}
			} );
		}

		function reviewsFormSubmit() {
			let fields = [
				'#comment',
				'#author',
				'#email'
			];

			let emailRegex = /\S+@\S+\.\S+/;
			let errorClass = 'review-input-error';

			$( '#write-product-review form' ).on( 'submit', function( e ) {
				let error = false;
				
				fields.forEach( function( field ) {
					let $fieldElement = $( field );
					let fieldValue = $fieldElement.val();
					$fieldElement.removeClass( errorClass );

					if (
						$fieldElement.length && !fieldValue ||
						( $fieldElement.length && field === '#email' && !emailRegex.test( fieldValue ) )
					) {
						$fieldElement.addClass( errorClass );

						error = true;
					}

				} );
				
				if ( error ) {
					e.preventDefault();
				}
			} );
		}

		function reviewsSlider() {
			$sectionInstance.find( '.js-swiper-reviews' ).each( function() {
				const $slider = $( this );

				window.app.main.customScrollbarsForSection( this );
				
				if ( this.swiper ) {
					this.swiper.destroy( true, true );
				}

				const slideCount = $slider.children( '.swiper-wrapper' ).children( '.swiper-slide' ).length;
				let loop = false;
				let rewind = true;

				const handleSliderSettings = () => {
					if (
						slideCount > 3 && window.matchMedia( 'screen and (min-width: 1025px)' ).matches ||
						slideCount > 4 && window.matchMedia( 'screen and (min-width: 2000px)' ).matches ||
						slideCount > 2 && window.matchMedia( 'screen and (max-width: 1024.5px)' ).matches
					) {
						loop = true;
						rewind = false;
					}
				};

				const loadSlider = () => {
					handleSliderSettings();
					
					new Swiper( $slider[0], {
						slidesPerView: 'auto',
						slidesPerGroup: 1,
						speed: 1000,
						spaceBetween: 8,
						slideToClickedSlide: true,
						rewind,
						loop,
						loopedSlides: 10,
						simulateTouch: false,
						a11y: {
							enabled: false
						},
						navigation: {
							nextEl: $slider.find( '.swiper-button-next' )[0],
							prevEl: $slider.find( '.swiper-button-prev' )[0],
						},
						breakpoints: {
							768: {
								spaceBetween: 12,
							},
							1280: {
								spaceBetween: 24,
							},
							1720: {
								spaceBetween: 30,
							}
						}
					} );
		
					if (
						$slider.find( '.swiper-button-prev' ).hasClass( 'swiper-button-lock' ) &&
						$slider.find( '.swiper-button-next' ).hasClass( 'swiper-button-lock' )
					) {
						$slider.find( '.swiper-controls' ).addClass( 'd-none' );
					} else {
						$slider.find( '.swiper-controls' ).removeClass( 'd-none' );
					}				
				};

				window.app.loadVendor( 'Swiper', loadSlider );
			} );

		}

		reviewsFormPreparation();
		reviewsFormSubmit();
		reviewsSlider();
	};

	window.app.loadBlock( initBlock, 'section-woo-product-reviews', '.section-woo-product-reviews' );		
} )( jQuery );